import { Tab as HeadlessUiTab } from '@headlessui/react';
import cn from 'classnames';
import { forwardRef } from 'react';

interface TabButton
  extends Pick<
    JSX.IntrinsicElements['button'],
    'children' | 'className' | 'onClick'
  > {
  badge?: number;
  iconStart?: React.ReactNode;
}

// Figma component name: 'Tab'
export const TabButton = forwardRef<HTMLButtonElement, TabButton>(
  ({ badge, children, className, iconStart, onClick }, ref) => (
    <HeadlessUiTab
      ref={ref}
      as="button"
      className={cn(
        'flex items-center gap-2 text-nowrap rounded-lg px-4 py-2 text-14 font-medium text-gray-600 outline-none transition duration-200 hover:bg-gray-200 active:bg-gray-300 data-[selected]:bg-blue-500 data-[selected]:bg-opacity-8 data-[selected]:text-blue-500',
        className,
      )}
      type="button"
      onClick={onClick}
    >
      {iconStart && (
        <span className="[&>svg]:h-3.5 [&>svg]:w-3.5">{iconStart}</span>
      )}
      <span>{children}</span>
      {badge && <span>{badge}</span>}
    </HeadlessUiTab>
  ),
);
